module.exports = __webpack_public_path__ + "media/dashboard/assets/images/analytics-icon-6b2c563e47959214a7719207f1d7b883.svg";